export default __webpack_public_path__ + "static/media/toast-icon.e5e700e9.svg";